"use client"
import React, { useEffect, useRef, useState } from "react"

interface ScrollableRowProps {
    children: React.ReactNode
}

const ScrollableRow: React.FC<ScrollableRowProps> = ({ children }) => {
    const [isScrolled, setIsScrolled] = useState(false)
    const [isScrolledToEnd, setIsScrolledToEnd] = useState(false)
    const containerRef = useRef<HTMLDivElement>(null)

    const checkScroll = () => {
        if (containerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = containerRef.current
            const isScrolled = scrollLeft > 0
            const isScrolledToEnd = scrollLeft + clientWidth >= scrollWidth
            setIsScrolled(isScrolled)
            setIsScrolledToEnd(isScrolledToEnd)
        }
    }

    useEffect(() => {
        const container = containerRef.current
        container?.addEventListener("scroll", checkScroll)
        checkScroll() // Initial check to set the state correctly on mount

        return () => {
            container?.removeEventListener("scroll", checkScroll)
        }
    }, [])

    return (
        <div className="relative flex items-center">
            <div
                className={`pointer-events-none absolute inset-y-0 left-0 w-[105px] bg-gradient-to-r from-white to-transparent ${!isScrolled ? "hidden" : ""}`}
            ></div>
            <div
                ref={containerRef}
                className="flex space-x-8 overflow-x-scroll py-2 scrollbar-hide"
                onScroll={checkScroll}
            >
                {children}
            </div>
            <div
                className={`pointer-events-none absolute inset-y-0 right-0 w-[105px] bg-gradient-to-l from-white to-transparent ${isScrolledToEnd ? "hidden" : ""}`}
            ></div>
        </div>
    )
}

export default ScrollableRow
